import React from 'react'
import PropTypes from 'prop-types'

const Row = ({ children, noGutters, smallGutters, className }) => {
  const htmlClasses = ['row', className]
  smallGutters && htmlClasses.push('row--small-gutters')
  noGutters && htmlClasses.push('no-gutters')

  return (
    <div className={htmlClasses.join(' ')}>
      {children}
    </div>
  )
}

Row.propTypes = {
  children: PropTypes.node.isRequired,
  noGutters: PropTypes.bool,
  smallGutters: PropTypes.bool,
  className: PropTypes.string
}

Row.defaultProps = {
  noGutters: false,
  smallGutters: false,
  className: ''
}

export default Row
